import React from "react";
import styled from "styled-components";

export const H5 = styled.h5`
    /* SETTINGS DESCRIPTION */
    margin-top: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--foreground);
`;
